import { Component } from '@angular/core';
import { HeaderComponent } from '../../../../layout/header/header.component';
import { NavbarComponent } from '../../../../layout/navbar/navbar.component';
import { SidebarComponent } from '../../../../layout/sidebar/sidebar.component';
import { RoutelinksService } from '../../../../services/core/routelinks.service';
import { CommonModule } from '@angular/common';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import {
  TranslatePipe,
  TranslateDirective,
  TranslateService,
  LangChangeEvent,
} from '@ngx-translate/core';
import { AlertComponentComponent } from '../../../../components/alert/alert-component.component';
import { PaginatorComponent } from '../../../../components/paginator/paginator.component';
import { VatRateService } from '../../../../services/vatRate.services';
import {
  VatRateTypeDto,
  VatRateTypeRequest,
  VatRateTypeResponse,
} from '../../../../models/vatRate/vatRateTypeDto.model';
import {
  VatRateDto,
  VatRateRequest,
  VatRateResponse,
} from '../../../../models/vatRate/vatRateDto.model';
import { messageVisibility } from '../../../../models/messageVisibility.model';
import { SharedService } from '../../../../services/shared.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-ivatypessection',
  standalone: true,
  imports: [
    HeaderComponent,
    NavbarComponent,
    SidebarComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslatePipe,
    TranslateDirective,
    PaginatorComponent,
    AlertComponentComponent,
  ],
  templateUrl: './ivatypessection.component.html',
  styleUrl: './ivatypessection.component.css',
})
export class IvatypessectionComponent {
  links: any[] = [];

  typesVatFormVisible: boolean = false;
  vatFormVisible: boolean = false;

  vatRate: VatRateDto = new VatRateDto();
  listVatRate!: VatRateDto[];
  vatRateSelected!: VatRateDto;
  vatResponse: VatRateResponse = new VatRateResponse();
  modelRequest: VatRateRequest = new VatRateRequest();
  vatRateType: VatRateTypeDto = new VatRateTypeDto();
  typeVatResponse: VatRateTypeResponse = new VatRateTypeResponse();
  typeModelRequest: VatRateTypeRequest = new VatRateTypeRequest();

  selectedRowId: any = null;
  selectedTypesRowId: any = null;
  datePK: string = '';
  controlPag: string = '';
  errorMessage: string = '';
  private langChangeSubscription!: Subscription;

  messageVisibility: messageVisibility = {
    isErrorFirts: false,
    isErrorSecond: false,
    isSuccessFirst: false,
    isSuccessSecond: false,
  };

  constructor(
    private routelinks: RoutelinksService,
    private translateService: TranslateService,
    private vatRateService: VatRateService,
    private sharedService: SharedService
  ) {}

  vatForm = new FormGroup({
    idVatRate: new FormControl(0),
    descriptionCat: new FormControl('', Validators.required),
    descriptionCast: new FormControl('', Validators.required),
    descriptionIng: new FormControl('', Validators.required),
  });

  typesVatForm = new FormGroup({
    percentage: new FormControl(0, [
      Validators.min(0),
      Validators.max(100),
      Validators.required,
    ]),
    startDate: new FormControl('', Validators.required),
    endDate: new FormControl(''),
  });

  ngOnInit(): void {
    this.links = this.routelinks.linksIVATypes;
    this.loadVatRates();
    // Servicio encargado de escuchar cuando se cambia de página
    this.sharedService.numberPageEventEmitter.subscribe((page: number) => {
      this.modelRequest.pageRequest.page = page;
      this.controlPag == 'vatResponse' ? this.loadVatRates() : null;
      this.controlPag == 'vatResponse' ? (this.selectedRowId = null) : null;
      this.vatFormVisible = false;
    });
    this.langChangeSubscription = this.translateService.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.loadVatRates();
      }
    );
  }

  ngOnDestroy(): void {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe(); // Desuscribirse del evento de cambio de idioma
    }
  }

  controlPaginator(control: any) {
    this.controlPag = control;
  }

  loadVatRates() {
    this.vatRateService
      .getListVatRate(this.modelRequest.pageRequest)
      .subscribe({
        next: (response) => {
          if (response != null) {
            console.log(response);
            this.listVatRate = response.listVatRate;
            this.vatResponse.vatRateTypeDto = response.listVatRate.map(
              (rt: any) => {
                return {
                  ...rt,
                  vatRateTraductionDto: rt.vatRateTraductionDto.filter(
                    (t: any) =>
                      t.languageDto.code.includes(
                        this.translateService.currentLang || 'es'
                      )
                  ),
                };
              }
            );
            response.pageDto !== undefined
              ? (this.vatResponse.pageDto = response.pageDto)
              : null;
          }
        },
        error: (error) => {
          this.vatResponse.vatRateTypeDto = [];
        },
      });
  }

  loadTypeVatRates(id: number) {
    this.vatRateService
      .getListTypeVatRate(this.modelRequest.pageRequest)
      .subscribe({
        next: (response) => {
          if (response != null) {
            response.pageDto !== undefined
              ? (this.typeVatResponse.pageDto = response.pageDto)
              : null;
            this.typeVatResponse.listVatRateType =
              response.listVatRateType.filter(
                (list: { idVatRateTypePkDto: { vatRateId: number } }) => {
                  return list.idVatRateTypePkDto.vatRateId == id;
                }
              );
          }
        },
        error: (error) => {
          this.typeVatResponse.listVatRateType = []; // Asigna una lista vacía en caso de error
        },
      });
  }

  loadVatRatesById() {
    this.vatRateService.getVatRateById(this.selectedRowId).subscribe({
      next: (response) => {
        this.vatRate = response;

        const catalanIndex =
          this.vatRate?.vatRateTraductionDto?.findIndex(
            (translation) => translation.languageDto?.code === 'ca'
          ) ?? -1;

        const spanishIndex =
          this.vatRate?.vatRateTraductionDto?.findIndex(
            (translation) => translation.languageDto?.code === 'es'
          ) ?? -1;

        const englishIndex =
          this.vatRate?.vatRateTraductionDto?.findIndex(
            (translation) => translation.languageDto?.code === 'en'
          ) ?? -1;

        this.vatForm.patchValue({
          idVatRate: this.vatRate?.idVatRate || 0,
          descriptionCast:
            spanishIndex >= 0
              ? this.vatRate?.vatRateTraductionDto?.[spanishIndex]
                  ?.description || ''
              : '',
          descriptionCat:
            catalanIndex >= 0
              ? this.vatRate?.vatRateTraductionDto?.[catalanIndex]
                  ?.description || ''
              : '',
          descriptionIng:
            englishIndex >= 0
              ? this.vatRate?.vatRateTraductionDto?.[englishIndex]
                  ?.description || ''
              : '',
        });
      },
      error: (err) => {},
    });
  }

  toggleRow(row: any): void {
    if (this.selectedRowId === row.idVatRate) {
      this.vatFormVisible = false;
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.selectedRowId = null;
      }, 350);
    } else {
      this.vatFormVisible = true; // Cambia a modo de edicion
      this.selectedRowId = row.idVatRate; // Selecciona la nueva fila
      this.vatRateSelected = row;
      this.loadVatRatesById();
      this.loadTypeVatRates(row.idVatRate);
      this.vatForm.get('idVatRate')?.disable();
      window.scrollTo(0, 600);
    }
  }

  toggleRowTypes(row: any): void {
    if (this.datePK === row.idVatRateTypePkDto?.startDate) {
      this.typesVatFormVisible = false;
      this.datePK = '';
      window.scrollTo(0, 0);
      setTimeout(() => {
        this.selectedTypesRowId = null;
      }, 350);
    } else {
      this.typesVatFormVisible = true; // Cambia a modo de edicion
      this.selectedTypesRowId = row.idVatRateTypePkDto?.vatRateId;
      this.datePK = row.idVatRateTypePkDto?.startDate;
      this.vatRateType = row;
      this.typesVatForm.get('percentage')?.patchValue(row.vatPercentage);
      this.typesVatForm
        .get('startDate')
        ?.patchValue(row.idVatRateTypePkDto?.startDate);
      this.typesVatForm.get('startDate')?.disable();
      this.typesVatForm.get('endDate')?.patchValue(row.endDate);

      window.scrollTo(0, 600);
    }
  }

  newVat() {
    this.vatFormVisible = true;
    this.typesVatFormVisible = false;
    this.selectedRowId = this.selectedTypesRowId = null; // Deselecciona si ya estaba seleccionada
    this.datePK = '';
    this.vatForm.enable();
    this.vatForm.reset();
  }

  newTypeVat() {
    this.datePK = '';
    this.typesVatFormVisible = true;
    this.selectedTypesRowId = null; // Deselecciona si ya estaba seleccionada
    this.typesVatForm.enable();
    this.typesVatForm.reset();
  }

  saveOrUpdateVatRate() {
    if (this.vatForm.valid) {
      this.resetMessageVisibility();
      this.bindFormToObj();
      if (this.vatForm.valid) {
        if (this.selectedRowId == null) {
          this.vatRateService.insertVatRate(this.vatRate).subscribe({
            next: (response: any) => {
              this.messageVisibility.isSuccessFirst = true;
              this.messageVisibility.isErrorFirts = false;
              this.errorMessage = "S'ha creat correctament";
              this.vatFormVisible = false;
              this.loadVatRates(); // Recarga la lista de tasas administrativas
              window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
            },
            error: (err) => {
              this.messageVisibility.isSuccessFirst = false;
              this.messageVisibility.isErrorFirts = true;
              this.errorMessage = err.error.message;
              console.error('Error al crear la tasa administrativa:', err);
            },
          });
        } else {
          this.vatRateService.updateVatRate(this.vatRate).subscribe({
            next: (response: any) => {
              this.errorMessage = "S'ha editat correctament";
              this.messageVisibility.isSuccessFirst = true;
              this.messageVisibility.isErrorFirts = false;
              this.loadVatRates(); // Recarga la lista de tasas administrativas
              window.scrollTo(0, 0); // Desplaza la vista al inicio de la página
            },
            error: (err: { error: { message: any } }) => {
              console.log(err.error);
              this.messageVisibility.isSuccessFirst = false;
              this.messageVisibility.isErrorFirts = true;
              this.errorMessage = err.error.message;
            },
          });
        }
      }
    } else {
      this.messageVisibility.isSuccessFirst = false;
      this.messageVisibility.isErrorFirts = true;
      this.errorMessage = 'obligatorios';
    }
  }

  saveOrUpdateVatRateType() {
    if (
      this.controlDates(
        this.typesVatForm.get('startDate')?.value,
        this.typesVatForm.get('endDate')?.value
      )
    ) {
      this.messageVisibility.isErrorFirts = false;
      this.messageVisibility.isSuccessFirst = false;
      this.messageVisibility.isSuccessSecond = false;
      this.messageVisibility.isErrorSecond = true;
      this.errorMessage = 'fechas';
      return;
    }
    if (this.typesVatForm.valid) {
      this.resetMessageVisibility();
      if (this.selectedTypesRowId == null) {
        this.buildVatRateType();
        this.vatRateService.insertTypeVatRate(this.vatRateType).subscribe({
          next: (response: any) => {
            this.messageVisibility.isSuccessSecond = true;
            this.errorMessage = "S'ha creat correctament";
            this.typesVatFormVisible = false;
            this.loadTypeVatRates(this.selectedRowId);
          },
          error: (err) => {
            this.messageVisibility.isErrorSecond = true;
            this.errorMessage = err.error.message;
          },
        });
      } else {
        this.vatRateType.vatPercentage =
          this.typesVatForm.get('percentage')?.value || 0;
        this.vatRateType.endDate =
          this.typesVatForm.get('endDate')?.value || '';
        this.vatRateType.idVatRateTypePkDto
          ? (this.vatRateType.idVatRateTypePkDto.startDate =
              this.typesVatForm.get('startDate')?.value || '')
          : '';

        this.vatRateService.updateTypeVatRate(this.vatRateType).subscribe({
          next: (response: any) => {
            this.messageVisibility.isSuccessSecond = true;
            this.messageVisibility.isErrorSecond = false;
            this.errorMessage = "S'ha editat correctament";
            this.loadTypeVatRates(this.selectedRowId);
          },
          error: (err) => {
            console.log(err);
            this.messageVisibility.isSuccessSecond = false;
            this.messageVisibility.isErrorSecond = true;
            this.errorMessage = err.error.message;
          },
        });
      }
    } else {
      this.messageVisibility.isSuccessSecond = false;
      this.messageVisibility.isErrorSecond = true;
      this.errorMessage = 'obligatorios';
    }
  }

  onCancel() {
    this.vatFormVisible = false;
    this.selectedRowId = this.selectedTypesRowId = null;
  }

  onCancelType() {
    this.datePK = '';
    this.typesVatFormVisible = false;
    this.selectedTypesRowId = null;
  }

  bindFormToObj() {
    if (this.selectedRowId != null) {
      this.vatRate.idVatRate = this.selectedRowId || undefined; // Asigna el ID de la tasa académica seleccionada
      this.selectedRowId == 0 ? (this.vatRate.idVatRate = 0) : null;
    } else {
      this.vatRate = new VatRateDto(); // Inicializa de 0 el objeto
      if (this.vatRate.vatRateTraductionDto) {
        this.vatRate.vatRateTraductionDto = [
          {
            languageDto: { idLanguage: 1 },
            idVatRateTraduction: undefined,
            description: undefined,
          },
          {
            languageDto: { idLanguage: 2 },
            idVatRateTraduction: undefined,
            description: undefined,
          },
          {
            languageDto: { idLanguage: 3 },
            idVatRateTraduction: undefined,
            description: undefined,
          },
        ]; // Inicializa ownAcademicFeeTraductionDto si es undefined o vacío; // Inicializa el array de traducciones si es nulo
      }
    }
    this.vatRate.active = this.vatForm.get('active')?.value || 'S'; // Asigna el estado activo
    this.vatRate.vatRateTraductionDto?.forEach((translation) => {
      if (
        translation.languageDto?.code === 'es' ||
        translation.languageDto?.idLanguage === 1
      ) {
        translation.description =
          this.vatForm.get('descriptionCast')?.value ?? undefined;
      } else if (
        translation.languageDto?.code === 'ca' ||
        translation.languageDto?.idLanguage === 2
      ) {
        translation.description =
          this.vatForm.get('descriptionCat')?.value ?? undefined;
      } else if (
        translation.languageDto?.code === 'en' ||
        translation.languageDto?.idLanguage === 3
      ) {
        translation.description =
          this.vatForm.get('descriptionIng')?.value ?? undefined;
      }
    });
  }

  buildVatRateType(): void {
    this.vatRateType.idVatRateTypePkDto = {
      startDate: this.typesVatForm.get('startDate')?.value || '',
      vatRateId: this.vatRateSelected.idVatRate,
    };
    this.vatRateType.vatRateDto = { idVatRate: this.vatRateSelected.idVatRate };
    this.vatRateType.endDate = this.typesVatForm.get('endDate')?.value || '';
    this.vatRateType.vatPercentage =
      this.typesVatForm.get('percentage')?.value || 0;
  }

  resetMessageVisibility() {
    this.messageVisibility.isErrorFirts =
      this.messageVisibility.isErrorSecond =
      this.messageVisibility.isSuccessFirst =
      this.messageVisibility.isSuccessSecond =
        false;
  }

  controlDates(startDate: any, dateEnd: any): boolean {
    if (!dateEnd) {
      return false;
    }
    return new Date(startDate) > new Date(dateEnd) ? true : false;
  }
}
